import { render, staticRenderFns } from "./ProjectSchemesTableItem.vue?vue&type=template&id=553ee655&scoped=true&"
import script from "./ProjectSchemesTableItem.vue?vue&type=script&lang=js&"
export * from "./ProjectSchemesTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSchemesTableItem.vue?vue&type=style&index=0&id=553ee655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ee655",
  null
  
)

export default component.exports